import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useEffect } from "react";


const editSoCouponSettingByRestaurantSchema = yup.object().shape({
  branch_score: yup.number().required('入力必須項目です'),
  socoupon_in_use: yup.string().required('入力必須項目です'),
  g_url: yup.string(),
  default_url: yup.string(),
  remind: yup.boolean(),
  qr_card_img: yup.mixed().nullable(),
});
type SoCouponSetting = {
  id: string;
  restaurant: string;
  branch_score: number;
  g_url: string;
  default_url: string;
  socoupon_in_use: string|null;
  remind: boolean;
}

export const useEditSoCouponSettingFormForRestaurant = (soCouponSetting?: SoCouponSetting) => {
  const { handleSubmit, register, control, formState: { errors, isSubmitting }, setValue } = useForm({
    resolver: yupResolver(editSoCouponSettingByRestaurantSchema),
    defaultValues: {
      branch_score: soCouponSetting?.branch_score ?? 5,
      socoupon_in_use: soCouponSetting?.socoupon_in_use ?? '',
      g_url: soCouponSetting?.g_url || '',
      default_url: soCouponSetting?.default_url || '',
      remind: soCouponSetting?.remind ?? false,
      qr_card_img: null  // ✅ 明示的に初期化（重要！）

    }

  });

  useEffect(() => {
    if (soCouponSetting) {
      setValue('branch_score', soCouponSetting.branch_score);
      setValue('socoupon_in_use', soCouponSetting.socoupon_in_use ?? '');
      setValue('remind', soCouponSetting.remind);
    }
  }, [soCouponSetting]);

  return {
    handleSubmit,
    register,
    control,
    isSubmitting,
    errors,
    setValue
  };
};